import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "linkedin",
  "use": "linkedin-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"linkedin\"><path d=\"M115 512H10V170h105v342zM61 125C29 125 0 96 0 61S29 0 61 0c35 0 61 29 61 61 0 35-26 64-61 64zm451 387H406V346c0-39 0-90-54-90s-64 42-64 86v170H182V170h103v48c13-26 48-55 99-55 109 0 128 71 128 163z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/linkedin.svg
// module id = 197
// module chunks = 0